import { Link } from "react-router-dom";
import { APP_ROUTES } from "../../navigation/sidebarNavConfig";

const SIZE_STYLES = {
  sm: {
    row: "text-[16px] leading-none sm:text-[17px]",
    sub: "mt-1 text-[11px] font-bold tracking-[0.28em] text-white/88 sm:text-[12px] sm:tracking-[0.3em]",
  },
  md: {
    row: "text-[26px] leading-none sm:text-[28px]",
    sub: "mt-1.5 text-[13px] font-bold tracking-[0.3em] text-white/90 sm:mt-2 sm:text-[14px]",
  },
  lg: {
    row: "text-[32px] leading-none sm:text-[36px]",
    sub: "mt-2 text-[14px] font-bold tracking-[0.32em] text-white/90 sm:text-[15px]",
  },
};

function WordmarkInner({ size, showSubtitle }) {
  const s = SIZE_STYLES[size] ?? SIZE_STYLES.md;

  return (
    <div className="inline-flex max-w-full flex-col items-center text-center select-none">
      <div
        className={[
          "ah-wordmark-en inline-flex items-baseline justify-center whitespace-nowrap leading-none",
          s.row,
        ].join(" ")}
      >
        <span className="font-black tracking-[-0.065em] text-emerald-400">A</span>
        <span className="font-black tracking-[-0.018em] text-white">nime</span>
        <span className="ml-[0.08em] font-black italic tracking-[-0.048em] text-white">
          House
        </span>
      </div>
      {showSubtitle ? (
        <div lang="ja" className={["ah-wordmark-ja max-w-full", s.sub].join(" ")}>
          アニメの家
        </div>
      ) : null}
    </div>
  );
}

/**
 * AnimeHouse logotype + optional Japanese tagline. Uses global `.ah-wordmark-en` /
 * `.ah-wordmark-ja` (Outfit + Noto Sans JP) from `index.css`.
 *
 * @param {"sm"|"md"|"lg"} [size="md"]
 * @param {string} [className] — merged onto the outermost wrapper (Link or div)
 * @param {boolean} [showSubtitle=true]
 * @param {boolean} [asLink=false] — wrap in react-router `<Link>`
 * @param {string} [to] — link target when `asLink` (defaults to `APP_ROUTES.home`)
 * @param {string} [linkClassName] — extra classes when `asLink` (focus ring, layout)
 */
export default function AnimeHouseWordmark({
  size = "md",
  className = "",
  showSubtitle = true,
  asLink = false,
  to,
  linkClassName = "",
}) {
  const inner = <WordmarkInner size={size} showSubtitle={showSubtitle} />;

  if (asLink) {
    const href = to ?? APP_ROUTES.home;
    return (
      <Link
        to={href}
        className={[linkClassName, className].filter(Boolean).join(" ")}
      >
        {inner}
      </Link>
    );
  }

  return <div className={className}>{inner}</div>;
}
